export enum TemperatureSections {
    SmartArm1 = "smartArm1",
    SmartArm2 = "smartArm2",
    SmartArm3 = "smartArm3"
}